import {AccountType} from "@/lib/types/accounts.ts";
import {Plan} from "@/lib/types/billing.ts";

export const accountCanPurchase = (type: AccountType, hasSubscription: boolean) => {
  return type === AccountType.REGULAR && hasSubscription;
};

export const isCustomPlan = (name: string) => {
  // TODO: change/update this when impplementing InstantCheckout for Billing2.0
  return ![Plan.Starter, Plan.Essential, Plan.Premium]
    .map((x) => x.toString().toUpperCase())
    .includes((name || "").toUpperCase());
};
